import gql from 'graphql-tag';

// Template management mutations
export const CLONE_TEMPLATE = gql`
  mutation CloneTemplate($request: AWSJSON!) {
    cloneTemplate(request: $request)
  }
`;

export const UPDATE_TEMPLATE_ITEMS = gql`
  mutation UpdateTemplateItems($request: AWSJSON!) {
    updateTemplateItems(request: $request)
  }
`;

export const PUBLISH_TEMPLATE = gql`
  mutation PublishTemplate($request: AWSJSON!) {
    publishTemplate(request: $request)
  }
`;

export const UNPUBLISH_TEMPLATE = gql`
  mutation UnpublishTemplate($request: AWSJSON!) {
    unpublishTemplate(request: $request)
  }
`;

export const CREATE_NEW_TEMPLATE_VERSION = gql`
  mutation CreateNewTemplateVersion($request: AWSJSON!) {
    createNewTemplateVersion(request: $request)
  }
`;

// Finding type management mutations
export const CREATE_FINDING_TYPE = gql`
  mutation CreateFindingType($request: AWSJSON!) {
    createFindingType(request: $request)
  }
`;

export const UPDATE_FINDING_TYPE = gql`
  mutation UpdateFindingType($request: AWSJSON!) {
    updateFindingType(request: $request)
  }
`;

export const DELETE_FINDING_TYPE = gql`
  mutation DeleteFindingType($request: AWSJSON!) {
    deleteFindingType(request: $request)
  }
`;

// Zone management mutations
export const CREATE_ZONE = gql`
  mutation CreateZone($request: AWSJSON!) {
    createZone(request: $request)
  }
`;

export const UPDATE_ZONE = gql`
  mutation UpdateZone($request: AWSJSON!) {
    updateZone(request: $request)
  }
`;

export const DELETE_ZONE = gql`
  mutation DeleteZone($request: AWSJSON!) {
    deleteZone(request: $request)
  }
`;
